import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Oval } from "react-loader-spinner";
import Header from "../../component/Header";
import Sidebar from "../../component/Sidebar";
import CustomerSSidebar from "../CustomerService/components/CustomerSSidebar";
import { toast } from "react-toastify";
import EthioOthers from "./EthioOthers";
import noImage from "../../images/errors.png";
import MonthFilter from "../../hooks/MonthFilter";

const apiUrl = process.env.REACT_APP_API_URL;
const userId = localStorage.getItem("token");

function EthioProducts() {
  const location = useLocation();
  const isEmbeddedInAdmin = location.pathname.toLowerCase().includes("admin");
  const [filteredData, setFilteredData] = useState([]);
  const [editableFields, setEditableFields] = useState({});
  const [filterDay, setFilterDay] = useState("");
  const [filterStatusP, setFilterStatusP] = useState("");
  const [filterModel, setFilterModel] = useState("");

  const [errors, setErrors] = useState(null);
  const [brand, setBrand] = useState("Samsung");
  const [model, setModel] = useState("");
  const [sim, setSim] = useState("");
  const [ram, setRam] = useState("");
  const [storage, setStorage] = useState("");
  const [delivery, setDelivery] = useState("");
  const [status, setStatus] = useState("");
  const [price, setPrice] = useState("");
  const [imageFile1, setImageFile1] = useState(null); // For the first image
  const [imageFile2, setImageFile2] = useState(null); // For the second image
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [editingRowId, setEditingRowId] = useState(null); // Track which row is being edited
  const [role, setRole] = useState(null);

  const [modelOther, setModelOther] = useState("");
  const [priceOther, setPriceOther] = useState("");
  const [quantityOther, setQuantityOther] = useState("");
  const [barcode, setBarcode] = useState("");
  const [barcodeOther, setBarcodeOther] = useState("");

  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [zoom, setZoom] = useState(1);

  let totalSoldPrice = 0;
  let totalProfit = 0;
  let totalBirrSum = 0;

  const [isMobile, setIsMobile] = useState(false);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const currentMonthShortForm = () => {
    const monthIndex = new Date().getMonth(); // Get current month index (0-11)
    return months[monthIndex];
  };

  const [selectedMonth, setSelectedMonth] = useState(currentMonthShortForm()); // Initialize to current month
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Added for year filter

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/ethioProducts`);
      const fetchedData = response.data.map((item) => ({
        ...item,
        imageUrl1: `${apiUrl}/uploads/${item.ImageFilename1}`,
        imageUrl2: `${apiUrl}/uploads/${item.ImageFilename2}`,
      }));
      const sortedData = sortByOrderNumber(fetchedData);
      setData(sortedData);
      setLoading(false);
      return sortedData; // return this
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
      return []; // fallback
    }
  };

  const openModal = (imageUrls) => {
    setImages(imageUrls);
    setCurrentIndex(0); // Start from the first image
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    setRole(storedRole);
  }, []);

  const monthToNumber = (month) => {
    const months = {
      Jan: 1,
      Feb: 2,
      Mar: 3,
      Apr: 4,
      May: 5,
      Jun: 6,
      Jul: 7,
      Aug: 8,
      Sep: 9,
      Oct: 10,
      Nov: 11,
      Dec: 12,
    };
    return months[month] || 0;
  };

  const parseMonthFromOrderNumber = (orderNumber) => {
    const monthPart = orderNumber.startsWith("E")
      ? orderNumber.slice(1, 4) // or .slice(1, 4) if E + 3-letter month
      : orderNumber.slice(0, 4);
    return monthPart.toUpperCase();
  };

  const sortByOrderNumber = (data) => {
    return data.sort((a, b) => {
      const [aMonth, aNumber] = [
        parseMonthFromOrderNumber(a.OrderNumber),
        parseInt(a.OrderNumber.slice(-2)),
      ];
      const [bMonth, bNumber] = [
        parseMonthFromOrderNumber(b.OrderNumber),
        parseInt(b.OrderNumber.slice(-2)),
      ];
      const aMonthNum = monthToNumber(aMonth);
      const bMonthNum = monthToNumber(bMonth);

      if (aMonthNum !== bMonthNum) {
        return bMonthNum - aMonthNum; // Sort by month first (descending)
      }
      return aNumber - bNumber; // Then by number (descending)
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const loadAndFilter = async () => {
      const sorted = await fetchData(); // Get full data
      const currentMonth = currentMonthShortForm(); // e.g. "Jun"
      const filtered = sorted.filter((item) =>
        item.OrderNumber.startsWith(`E${currentMonth}`)
      );
      setFilteredData(filtered); // set it directly
      setSelectedMonth(currentMonth); // reflect on UI
    };

    loadAndFilter();
  }, []);

  // Extend applyFilters
  const applyFilters = (data, month, year, day, status, model) => {
    let filtered = [...data];

    // Year filter (only if year is provided)
    if (year) {
      filtered = filtered.filter((item) => {
        const itemYear = new Date(item.TimeStamp).getFullYear();
        return itemYear === parseInt(year, 10);
      });
    }

    // Month filter (only if month is provided)
    if (month) {
      const monthUpper = month.toUpperCase();
      filtered = filtered.filter(
        (item) => parseMonthFromOrderNumber(item.OrderNumber) === monthUpper
      );
    }

    // Day filter
    if (day) {
      filtered = filtered.filter((item) => {
        const itemDay = new Date(item.TimeStamp).getDate();
        return itemDay === parseInt(day, 10);
      });
    }

    // Status filter
    if (status) {
      filtered = filtered.filter((item) => item.ourStat === status);
    }

    // Model filter
    if (model) {
      filtered = filtered.filter((item) =>
        item.Model?.toLowerCase().includes(model.toLowerCase())
      );
    }

    return filtered;
  };
  useEffect(() => {
    if (data.length > 0) {
      const filtered = applyFilters(
        data,
        selectedMonth,
        selectedYear,
        filterDay,
        filterStatusP,
        filterModel
      );
      setFilteredData(filtered);
    }
  }, [data, selectedMonth, selectedYear, filterDay, filterStatusP, filterModel]);

  const filterByMonthAndYear = (
    month = currentMonthShortForm(),
    year = new Date().getFullYear()
  ) => {
    setSelectedMonth(month);
    setSelectedYear(year);
    const filtered = applyFilters(data, month, year);
    setFilteredData(filtered);

    const sum = filtered.reduce(
      (acc, item) => acc + parseFloat(item.Price || 0),
      0
    );
    const receivedTotal = filtered.filter(
      (item) => item.Status === "Received"
    ).length;
    const sentTotal = filtered.filter((item) => item.Status === "Sent").length;
    const ordered = filtered.length;
  };

  const filterByMonthAll = (month = currentMonthShortForm()) => {
    if (month === "") {
      setFilteredData(data);
    } else {
      const filtered = data.filter((item) =>
        item.OrderNumber.startsWith(`E${month}`)
      );
      setFilteredData(filtered);
      setSelectedMonth(month);
      const sum = filtered.reduce(
        (acc, item) => acc + parseFloat(item.Price || 0),
        0
      );
      const receivedTotal = filtered.filter(
        (item) => item.Status === "Received"
      ).length;
      const sentTotal = filtered.filter(
        (item) => item.Status === "Sent"
      ).length;
      const ordered = filtered.length;
    }
  };

  const handleMonthSelect = (month) => {
    setSelectedMonth(month);
    filterByMonthAll(month); // Hide the dropdown after selection
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    filterByMonthAndYear(selectedMonth, year);
  };

  const getDaysInMonth = (month) => {
    const year = new Date().getFullYear(); // Use the current year
    return new Date(year, month, 0).getDate(); // Get the last day of the month
  };

  const handlePost = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const userId = localStorage.getItem("token");
      const formData = new FormData();

      formData.append("brand", brand);
      formData.append("model", model);
      formData.append("sim", sim);
      formData.append("ram", ram);
      formData.append("storage", storage);
      formData.append("status", status);
      formData.append("delivery", delivery);
      formData.append("price", price);
      formData.append("barcode", barcode);

      if (imageFile1) {
        formData.append("images", imageFile1);
      }
      if (imageFile2) {
        formData.append("images", imageFile2);
      }

      await axios.post(`${apiUrl}/ethioProducts`, formData, {
        headers: {
          Authorization: `Bearer ${userId}`,
          "Content-Type": "multipart/form-data",
        },
      });

      setLoading(false);
      reset();
      fetchData();
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  };

  const reset = () => {
    setBrand("Samsung");
    setModel("");
    setSim("");
    setRam("");
    setStorage("");
    setStatus("");
    setDelivery("");
    setPrice("");
    setImageFile1(null);
    setImageFile2(null);
  };

  const updateStatus = async (itemId, ourStat) => {
    try {
      setLoading(true);
      const res = await axios.put(
        `${apiUrl}/updateEthioStat`,
        {
          id: itemId,
          ourStat,
        },
        {
          headers: {
            Authorization: `Bearer ${userId}`,
          },
        }
      );

      fetchData();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  };

  const handleOptionSelect = (index, itemId, ourStat) => {
    setDropdownOpen(null); // Close the dropdown
    // Update the status in the frontend
    // setData(
    //   data.map((item) =>
    //     item.ID === itemId ? { item, ourStat: ourStat } : item
    //   )
    // );
    setData(
      data.map((item) => (item.ID === itemId ? { ...item, ourStat } : item))
    );

    // Update the status in the backend
    updateStatus(itemId, ourStat);
    // fetchData();
  };

  const toggleDropdown = (index) => {
    setDropdownOpen(dropdownOpen === index ? null : index);
  };

  const handleEdit = (itemId, field, currentValue) => {
    setEditingRowId(`${itemId}-${field}`);
    setEditableFields((prev) => ({
      ...prev,
      [`${itemId}-${field}`]: currentValue || "",
    }));
  };

  const handleBlur = async (itemId, field) => {
    const value = editableFields[`${itemId}-${field}`];
    setEditingRowId(null);

    try {
      await axios.put(
        `${apiUrl}/updateEthioProducts`,
        {
          id: itemId,
          [field]: value,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      // ✅ immediate visual update
      setData((prev) =>
        prev.map((item) =>
          item.ID === itemId ? { ...item, [field]: value } : item
        )
      );

      toast.success(`${field} updated successfully`);
      fetchData(); // optional full sync
    } catch (err) {
      toast.error(`Failed to update ${field}`);
      console.error(`Failed to update ${field}`, err);
    }
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${day}-${month}-${year}`; // Format as 'YYYY-MM-DD'
  };

  const handleOtherProductPost = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const userId = localStorage.getItem("token");
      const formData = new FormData();

      formData.append("model", modelOther);
      formData.append("price", priceOther);
      formData.append("quantity", quantityOther);
      formData.append("barcode", barcodeOther);

      if (imageFile1) {
        formData.append("images", imageFile1);
      }
      if (imageFile2) {
        formData.append("images", imageFile2);
      }

      await axios.post(`${apiUrl}/ethioPostOthers`, formData, {
        headers: {
          Authorization: `Bearer ${userId}`,
          "Content-Type": "multipart/form-data",
        },
      });

      setLoading(false);
      fetchData();
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  };

  const handleClear = () => {
    setFilterDay("");
    setFilterStatusP("");
    setFilterModel("");
  };

  return (
    <>
      {!isEmbeddedInAdmin && <Header />}
      {!isEmbeddedInAdmin && (role === "Admin" ? <Sidebar /> : <CustomerSSidebar />)}
      <div className={`items-center flex flex-col justify-center ${isEmbeddedInAdmin ? "mt-2 md:mt-4" : "mt-16 md:mt-24"} w-full px-1 md:px-4 overflow-x-hidden`}>
        <form onSubmit={handlePost} className="w-full md:w-11/12 bg-white p-3 md:p-6 rounded-xl border border-slate-200 shadow-sm mb-6">
          <h1 className="mb-3 font-bold text-lg">Phones</h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            <div className="relative w-full">
              <label
                htmlFor="model"
                className="absolute left-3 bg-white px-2 font text-gray-400"
                style={{ top: "-12px" }}
              >
                Brand
              </label>
              <select
                name="brand"
                id="brand"
                className="border p-2 w-full rounded"
                value={brand}
                onChange={(e) => setBrand(e.target.value)}
                defaultValue={"Samsung"}
              >
                <option value="" disabled>
                  Brand
                </option>
                <option value="Samsung">Samsung</option>
                <option value="iPhone">iPhone</option>
              </select>
            </div>

            {brand === "iPhone" ? (
              <div className="relative w-full">
                <label
                  htmlFor="model"
                  className="absolute left-3 bg-white px-2 font text-gray-400"
                  style={{ top: "-12px" }}
                >
                  Model
                </label>
                <select
                  name="model"
                  id="model"
                  className="border p-2 w-full rounded"
                  value={model}
                  onChange={(e) => setModel(e.target.value)}
                >
                  <option value="">Select iPhone Model</option>
                  <option value="iPhone 15 Pro Max">iPhone 15 Pro Max</option>
                  <option value="iPhone 15 Pro">iPhone 15 Pro</option>
                  <option value="iPhone 15 Plus">iPhone 15 Plus</option>
                  <option value="iPhone 15">iPhone 15</option>
                  <option value="iPhone 14 Pro Max">iPhone 14 Pro Max</option>
                  <option value="iPhone 14 Pro">iPhone 14 Pro</option>
                  <option value="iPhone 14 Plus">iPhone 14 Plus</option>
                  <option value="iPhone 14">iPhone 14</option>
                  <option value="iPhone SE (2022)">iPhone SE (2022)</option>
                  <option value="iPhone 13 Pro Max">iPhone 13 Pro Max</option>
                  <option value="iPhone 13 Pro">iPhone 13 Pro</option>
                  <option value="iPhone 13">iPhone 13</option>
                  <option value="iPhone 13 mini">iPhone 13 mini</option>
                  <option value="iPhone 12 Pro Max">iPhone 12 Pro Max</option>
                  <option value="iPhone 12 Pro">iPhone 12 Pro</option>
                  <option value="iPhone 12">iPhone 12</option>
                  <option value="iPhone 12 mini">iPhone 12 mini</option>
                  <option value="iPhone SE (2020)">iPhone SE (2020)</option>
                  <option value="iPhone 11 Pro Max">iPhone 11 Pro Max</option>
                  <option value="iPhone 11 Pro">iPhone 11 Pro</option>
                  <option value="iPhone 11">iPhone 11</option>
                  <option value="iPhone XS Max">iPhone XS Max</option>
                  <option value="iPhone XS">iPhone XS</option>
                  <option value="iPhone XR">iPhone XR</option>
                  <option value="iPhone X">iPhone X</option>
                  <option value="iPhone 8 Plus">iPhone 8 Plus</option>
                  <option value="iPhone 8">iPhone 8</option>
                  <option value="iPhone 7 Plus">iPhone 7 Plus</option>
                  <option value="iPhone 7">iPhone 7</option>
                  <option value="iPhone SE">iPhone SE</option>
                  <option value="iPhone 6s Plus">iPhone 6s Plus</option>
                  <option value="iPhone 6s">iPhone 6s</option>
                  <option value="iPhone 6 Plus">iPhone 6 Plus</option>
                  <option value="iPhone 6">iPhone 6</option>
                  <option value="iPhone 5s">iPhone 5s</option>
                  <option value="iPhone 5c">iPhone 5c</option>
                  <option value="iPhone 5">iPhone 5</option>
                  <option value="iPhone 4s">iPhone 4s</option>
                  <option value="iPhone 4">iPhone 4</option>
                  <option value="iPhone 4 CDMA">iPhone 4 CDMA</option>
                  <option value="iPhone 3GS">iPhone 3GS</option>
                  <option value="iPhone 3G">iPhone 3G</option>
                  <option value="iPhone">iPhone</option>
                </select>
              </div>
            ) : null}
            {brand === "Samsung" ? (
              <div className="relative w-full">
                <label
                  htmlFor="model"
                  className="absolute left-3 bg-white px-2 font text-gray-400"
                  style={{ top: "-12px" }}
                >
                  Model
                </label>
                <input
                  name="model"
                  id="model"
                  className="border p-2 w-full rounded"
                  value={model}
                  onChange={(e) => setModel(e.target.value)}
                />
              </div>
            ) : null}
            <div className="relative w-full">
              <label
                htmlFor="sim"
                className="absolute left-3 bg-white px-2 font text-gray-400"
                style={{ top: "-12px" }}
              >
                Sim
              </label>
              <select
                name="sim"
                id="sim"
                className="border p-2 w-full rounded"
                value={sim}
                onChange={(e) => setSim(e.target.value)}
              >
                <option value="" disabled>
                  Sim
                </option>
                <option value="dual">Dual</option>
                <option value="single">Single</option>
                <option value="esim">Single E-sim</option>
              </select>
            </div>
            {brand === "Samsung" ? (
              <div className="relative w-full">
                <label
                  htmlFor="ram"
                  className="absolute left-3 bg-white px-2 font text-gray-400"
                  style={{ top: "-12px" }}
                >
                  Ram
                </label>
                <select
                  name="ram"
                  id="ram"
                  className="border p-2 w-full rounded"
                  value={ram}
                  onChange={(e) => setRam(e.target.value)}
                >
                  <option value="" disabled>
                    Ram
                  </option>
                  <option value="4 GB">4 GB</option>
                  <option value="6 GB">6 GB</option>
                  <option value="8 GB">8 GB</option>
                  <option value="12 GB">12 GB</option>
                  <option value="16 GB">16 GB</option>
                </select>
              </div>
            ) : null}
            {brand === "iPhone" ? (
              <div className="relative w-full">
                <label
                  htmlFor="price"
                  className="absolute left-3 bg-white px-2 font text-gray-400"
                  style={{ top: "-12px" }}
                >
                  Battery
                </label>
                <input
                  className="border p-2 w-full rounded"
                  id="ram"
                  type="text"
                  placeholder="900"
                  value={ram}
                  onChange={(e) => setRam(e.target.value)}
                />
              </div>
            ) : null}
            <div className="relative w-full">
              <label
                htmlFor="storage"
                className="absolute left-3 bg-white px-2 font text-gray-400"
                style={{ top: "-12px" }}
              >
                Storage
              </label>
              <select
                name="storage"
                id="storage"
                className="border mb-4 p-2 w-full rounded"
                value={storage}
                onChange={(e) => setStorage(e.target.value)}
              >
                <option value="" disabled>
                  Storage
                </option>
                <option value="32 GB">32 GB</option>
                <option value="64 GB">64 GB</option>
                <option value="128 GB">128 GB</option>
                <option value="256 GB">256 GB</option>
                <option value="512 GB">512 GB</option>
                <option value="1 TB">1 TB</option>
              </select>
            </div>
            <div className="relative w-full">
              <label
                htmlFor="price"
                className="absolute left-3 bg-white px-2 font text-gray-400"
                style={{ top: "-12px" }}
              >
                Price
              </label>
              <input
                className="border p-2 w-full rounded"
                id="price"
                type="text"
                placeholder="900"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
            </div>

            <div className="relative w-full">
              <label
                htmlFor="delivery"
                className="absolute left-3 bg-white px-2 font text-gray-400"
                style={{ top: "-12px" }}
              >
                Delivery fee
              </label>
              <input
                className="border p-2 w-full rounded"
                id="delivery"
                type="text"
                placeholder="Delivery fee"
                value={delivery}
                onChange={(e) => setDelivery(e.target.value)}
              />
            </div>
            <div className="relative w-full">
              <label
                htmlFor="barcode"
                className="absolute left-3 bg-white px-2 font text-gray-400"
                style={{ top: "-12px" }}
              >
                Barcode
              </label>
              <input
                className="border p-2 w-full rounded"
                id="barcode"
                type="text"
                placeholder="Barcode (Optional)"
                value={barcode}
                onChange={(e) => setBarcode(e.target.value)}
              />
            </div>
            <div className="relative w-full">
              <label
                htmlFor="status"
                className="absolute left-3 bg-white px-2 font text-gray-400"
                style={{ top: "-12px" }}
              >
                Status
              </label>
              <select
                name="status"
                id="status"
                className="border mb-4 p-2 w-full rounded"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="" disabled>
                  Status
                </option>
                <option value="Ordered">Ordered</option>
                <option value="Received">Received</option>
                <option value="Sent">Sent</option>
                <option value="Return Received">Return Received</option>
                <option value="Return Sent">Return Sent</option>
              </select>
            </div>
          </div>
          <div className="flex flex-col w-full">
            <div className="relative w-full">
              <label
                htmlFor="file1"
                className="absolute left-3 bg-white px-2 font text-gray-400"
                style={{ top: "-12px" }}
              >
                Front
              </label>
              <input
                type="file"
                id="file1"
                onChange={(e) => setImageFile1(e.target.files[0])} // Save the first file in state
                className="text-sm w-full rounded text-stone-500 border-1 file:mr-5 file:p-3 file:px-12 file:border-0 file:text-xs file:font-medium file:bg-stone-50 file:text-stone-700 hover:file:cursor-pointer hover:file:bg-blue-50 hover:file:text-gray-900 mb-3"
              />
            </div>
            <div className="relative w-full">
              <label
                htmlFor="file2"
                className="absolute left-3 bg-white px-2 font text-gray-400"
                style={{ top: "-12px" }}
              >
                Back
              </label>
              <input
                type="file"
                id="file2"
                onChange={(e) => setImageFile2(e.target.files[0])} // Save the second file in state
                className="text-sm w-full rounded text-stone-500 border-1 file:mr-5 file:p-3 file:px-12 file:border-0 file:text-xs file:font-medium file:bg-stone-50 file:text-stone-700 hover:file:cursor-pointer hover:file:bg-blue-50 hover:file:text-gray-900 mb-3"
              />
            </div>
            {loading ? (
              <button className="bg-slate-600 hover:bg-slate-500 text-white font-bold py-2 px-4 mt-2 rounded">
                <Oval
                  height={20}
                  width={20}
                  color="#fff"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                  ariaLabel="oval-loading"
                  secondaryColor="#4fa94d"
                  strokeWidth={2}
                  strokeWidthSecondary={2}
                />
              </button>
            ) : (
              <button
                className="bg-slate-600 hover:bg-slate-500 text-white font-bold py-2 px-4 mt-2 rounded"
                type="submit"
              >
                Add
              </button>
            )}
          </div>
        </form>
        <form onSubmit={handleOtherProductPost} className="w-full md:w-11/12 bg-white p-3 md:p-6 rounded-xl border border-slate-200 shadow-sm mb-6">
          <div className="flex flex-col w-full pt-1">
            <h1 className="mb-3 font-bold text-lg">Other Products</h1>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
              <div className="relative w-full">
                <label
                  htmlFor="delivery"
                  className="absolute left-3 bg-white px-2 font text-gray-400"
                  style={{ top: "-12px" }}
                >
                  Name
                </label>
                <input
                  className="border p-2 w-full rounded"
                  id="delivery"
                  type="text"
                  placeholder="Product Name"
                  value={modelOther}
                  onChange={(e) => setModelOther(e.target.value)}
                />
              </div>

              <div className="relative w-full">
                <label
                  htmlFor="price"
                  className="absolute left-3 bg-white px-2 font text-gray-400"
                  style={{ top: "-12px" }}
                >
                  Price
                </label>
                <input
                  className="border p-2 w-full rounded"
                  id="price"
                  type="text"
                  placeholder="900"
                  value={priceOther}
                  onChange={(e) => setPriceOther(e.target.value)}
                />
              </div>
              <div className="relative w-full">
                <label
                  htmlFor="quantity"
                  className="absolute left-3 bg-white px-2 font text-gray-400"
                  style={{ top: "-12px" }}
                >
                  Quantity
                </label>
                <input
                  className="border p-2 w-full rounded"
                  id="quantity"
                  type="text"
                  placeholder="3"
                  value={quantityOther}
                  onChange={(e) => setQuantityOther(e.target.value)}
                />
              </div>

              <div className="relative w-full">
                <label
                  htmlFor="barcodeOther"
                  className="absolute left-3 bg-white px-2 font text-gray-400"
                  style={{ top: "-12px" }}
                >
                  Barcode
                </label>
                <input
                  className="border p-2 w-full rounded"
                  id="barcodeOther"
                  type="text"
                  placeholder="Barcode (Optional)"
                  value={barcodeOther}
                  onChange={(e) => setBarcodeOther(e.target.value)}
                />
              </div>
            </div>
            {loading ? (
              <button className="bg-slate-600 hover:bg-slate-500 text-white font-bold py-2 px-4 mt-3 rounded">
                <Oval
                  height={20}
                  width={20}
                  color="#fff"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                  ariaLabel="oval-loading"
                  secondaryColor="#4fa94d"
                  strokeWidth={2}
                  strokeWidthSecondary={2}
                />
              </button>
            ) : (
              <button
                className="bg-slate-600 hover:bg-slate-500 text-white font-bold py-2 px-4 mt-3 rounded"
                type="submit"
              >
                Add
              </button>
            )}
          </div>
        </form>
        <div className="relative max-h-[80vh] overflow-y-auto overflow-x-auto custom-scrollbar shadow-2xl rounded-2xl bg-white mt-4 md:mt-8 w-full md:w-11/12 mb-10 px-2 md:px-5 border border-slate-200">
          <h1 className="font-bold text-xl md:text-2xl my-3">Local Available Phones</h1>
          <MonthFilter
            months={months}
            selectedMonth={selectedMonth}
            handleMonthSelect={handleMonthSelect}
            selectedYear={selectedYear}
            handleYearChange={handleYearChange}
            filterDay={filterDay}
            setFilterDay={setFilterDay}
            filterStatusP={filterStatusP}
            setFilterStatusP={setFilterStatusP}
            filterModel={filterModel}
            setFilterModel={setFilterModel}
            handleClear={handleClear}
            getDaysInMonth={getDaysInMonth}
            isMobile={isMobile}
          />
          <table className="min-w-full text-xs md:text-sm text-left text-slate-700 whitespace-nowrap">
            <thead className="sticky top-0 z-20 bg-slate-800 text-white uppercase text-xs font-semibold tracking-widest shadow-md">
              <tr>
                <th className="px-2 md:px-4 py-2 md:py-4 z-20 border-b border-slate-700">
                  #
                </th>
                <th className="px-2 md:px-4 py-2 md:py-4 z-20 border-b border-slate-700">
                  Brand
                </th>
                <th className="px-2 md:px-4 py-2 md:py-4 z-20 border-b border-slate-700">
                  Model
                </th>
                <th className="px-2 md:px-4 py-2 md:py-4 z-20 border-b border-slate-700">
                  Storage
                </th>
                <th className="px-2 md:px-4 py-2 md:py-4 z-20 border-b border-slate-700">
                  Ram
                </th>
                <th className="px-2 md:px-4 py-2 md:py-4 z-20 border-b border-slate-700">
                  Sim
                </th>
                <th className="px-2 md:px-4 py-2 md:py-4 z-20 border-b border-slate-700">
                  Price
                </th>
                <th className="px-2 md:px-4 py-2 md:py-4 z-20 border-b border-slate-700">
                  Images
                </th>
                <th className="px-2 md:px-4 py-2 md:py-4 z-20 border-b border-slate-700">
                  Sold Price
                </th>
                <th className="px-2 md:px-4 py-2 md:py-4 z-20 border-b border-slate-700 text-green-400">
                  Profit
                </th>
                <th className="px-2 md:px-4 py-2 md:py-4 z-20 border-b border-slate-700">
                  Buyers
                </th>
                <th className="px-2 md:px-4 py-2 md:py-4 z-20 border-b border-slate-700">
                  Seller
                </th>
                <th className="px-2 md:px-4 py-2 md:py-4 z-20 border-b border-slate-700">
                  SoldDate
                </th>
                <th className="px-2 md:px-4 py-2 md:py-4 z-20 border-b border-slate-700">
                  ET Status
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, index) => {
                const soldPrice = Number(item.soldPrice);
                const Price = Number(item.Price);
                const profit = soldPrice - Price;
                totalBirrSum += Number(item.Price);
                totalProfit += profit;
                totalSoldPrice += Number(item.soldPrice);
                return (
                  <tr key={index}>
                    <td className="border-b-1 pb-3 border-slate-600 text-left font-bold text-slate-800 m-0 bg-gray-100">
                      {item.OrderNumber}
                    </td>
                    <td
                      className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200 cursor-pointer"
                      onDoubleClick={() =>
                        handleEdit(item.ID, "Brand", item.Brand)
                      }
                    >
                      {editingRowId === `${item.ID}-Brand` ? (
                        <input
                          type="text"
                          className="w-full border-1"
                          value={editableFields[`${item.ID}-Brand`] || ""}
                          onChange={(e) =>
                            setEditableFields((prev) => ({
                              ...prev,
                              [`${item.ID}-Brand`]: e.target.value,
                            }))
                          }
                          onBlur={() => handleBlur(item.ID, "Brand")}
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleBlur(item.ID, "Brand")
                          }
                          autoFocus
                        />
                      ) : (
                        item.Brand
                      )}
                    </td>
                    <td
                      className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100 cursor-pointer"
                      onDoubleClick={() =>
                        handleEdit(item.ID, "Model", item.Model)
                      }
                    >
                      {editingRowId === `${item.ID}-Model` ? (
                        <input
                          type="text"
                          className="w-full border-1"
                          value={editableFields[`${item.ID}-Model`] || ""}
                          onChange={(e) =>
                            setEditableFields((prev) => ({
                              ...prev,
                              [`${item.ID}-Model`]: e.target.value,
                            }))
                          }
                          onBlur={() => handleBlur(item.ID, "Model")}
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleBlur(item.ID, "Model")
                          }
                          autoFocus
                        />
                      ) : (
                        item.Model
                      )}
                    </td>
                    <td
                      className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200 cursor-pointer"
                      onDoubleClick={() =>
                        handleEdit(item.ID, "Storage", item.Storage)
                      }
                    >
                      {editingRowId === `${item.ID}-Storage` ? (
                        <input
                          type="text"
                          className="w-full border-1"
                          value={editableFields[`${item.ID}-Storage`] || ""}
                          onChange={(e) =>
                            setEditableFields((prev) => ({
                              ...prev,
                              [`${item.ID}-Storage`]: e.target.value,
                            }))
                          }
                          onBlur={() => handleBlur(item.ID, "Storage")}
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleBlur(item.ID, "Storage")
                          }
                          autoFocus
                        />
                      ) : (
                        item.Storage
                      )}
                    </td>
                    <td
                      className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100 cursor-pointer"
                      onDoubleClick={() =>
                        handleEdit(item.ID, "Ram", item.Ram)
                      }
                    >
                      {editingRowId === `${item.ID}-Ram` ? (
                        <input
                          type="text"
                          className="w-full border-1"
                          value={editableFields[`${item.ID}-Ram`] || ""}
                          onChange={(e) =>
                            setEditableFields((prev) => ({
                              ...prev,
                              [`${item.ID}-Ram`]: e.target.value,
                            }))
                          }
                          onBlur={() => handleBlur(item.ID, "Ram")}
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleBlur(item.ID, "Ram")
                          }
                          autoFocus
                        />
                      ) : (
                        item.Ram
                      )}
                    </td>
                    <td
                      className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200 cursor-pointer"
                      onDoubleClick={() =>
                        handleEdit(item.ID, "Sim", item.Sim)
                      }
                    >
                      {editingRowId === `${item.ID}-Sim` ? (
                        <input
                          type="text"
                          className="w-full border-1"
                          value={editableFields[`${item.ID}-Sim`] || ""}
                          onChange={(e) =>
                            setEditableFields((prev) => ({
                              ...prev,
                              [`${item.ID}-Sim`]: e.target.value,
                            }))
                          }
                          onBlur={() => handleBlur(item.ID, "Sim")}
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleBlur(item.ID, "Sim")
                          }
                          autoFocus
                        />
                      ) : (
                        item.Sim
                      )}
                    </td>
                    <td
                      className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100 cursor-pointer"
                      onDoubleClick={() =>
                        handleEdit(item.ID, "Price", item.Price)
                      }
                    >
                      {editingRowId === `${item.ID}-Price` ? (
                        <input
                          type="text"
                          className="w-full border-1"
                          value={editableFields[`${item.ID}-Price`] || ""}
                          onChange={(e) =>
                            setEditableFields((prev) => ({
                              ...prev,
                              [`${item.ID}-Price`]: e.target.value,
                            }))
                          }
                          onBlur={() => handleBlur(item.ID, "Price")}
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleBlur(item.ID, "Price")
                          }
                          autoFocus
                        />
                      ) : (
                        item.Price
                      )}
                    </td>
                    <td className="border-b-1 pb-3 border-slate-700 bg-gray-100 z-0">
                      {item.ImageFilename1 || item.ImageFilename2 ? (
                        <div className="flex flex-row gap-2 h-10">
                          {[item.imageUrl1, item.imageUrl2]
                            .filter(Boolean)
                            .map((img, index) => (
                              <img
                                key={index}
                                src={img}
                                alt=""
                                height="20"
                                width="20"
                                className="cursor-pointer"
                                onClick={() =>
                                  openModal(
                                    [item.imageUrl1, item.imageUrl2].filter(
                                      Boolean
                                    )
                                  )
                                }
                              />
                            ))}
                        </div>
                      ) : (
                        <img
                          src={noImage}
                          alt="No Image Available"
                          height="10"
                          width="50"
                          className="cursor-pointer"
                          onClick={() => openModal([noImage])}
                        />
                      )}
                    </td>
                    <td
                      className="border-b-1 pb-3 border-slate-600 text-left bg-gray-200 cursor-pointer"
                      onDoubleClick={() =>
                        handleEdit(item.ID, "soldPrice", item.soldPrice)
                      }
                    >
                      {editingRowId === `${item.ID}-soldPrice` ? (
                        <input
                          type="text"
                          className="w-full border-1"
                          value={editableFields[`${item.ID}-soldPrice`] || ""}
                          onChange={(e) =>
                            setEditableFields((prev) => ({
                              ...prev,
                              [`${item.ID}-soldPrice`]: e.target.value,
                            }))
                          }
                          onBlur={() => handleBlur(item.ID, "soldPrice")}
                          onKeyDown={(e) =>
                            e.key === "Enter" &&
                            handleBlur(item.ID, "soldPrice")
                          }
                          autoFocus
                        />
                      ) : (
                        item.soldPrice
                      )}
                    </td>
                    <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                      {profit}
                    </td>
                    <td
                      className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200 cursor-pointer"
                      onDoubleClick={() =>
                        handleEdit(item.ID, "buyer", item.buyer)
                      }
                    >
                      {editingRowId === `${item.ID}-buyer` ? (
                        <input
                          type="text"
                          className="w-full border-1"
                          value={editableFields[`${item.ID}-buyer`] || ""}
                          onChange={(e) =>
                            setEditableFields((prev) => ({
                              ...prev,
                              [`${item.ID}-buyer`]: e.target.value,
                            }))
                          }
                          onBlur={() => handleBlur(item.ID, "buyer")}
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleBlur(item.ID, "buyer")
                          }
                          autoFocus
                        />
                      ) : (
                        item.buyer
                      )}
                    </td>

                    <td
                      className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100 cursor-pointer"
                      onDoubleClick={() =>
                        handleEdit(item.ID, "seller", item.seller)
                      }
                    >
                      {editingRowId === `${item.ID}-seller` ? (
                        <input
                          type="text"
                          className="w-full border-1"
                          value={editableFields[`${item.ID}-seller`] || ""}
                          onChange={(e) =>
                            setEditableFields((prev) => ({
                              ...prev,
                              [`${item.ID}-seller`]: e.target.value,
                            }))
                          }
                          onBlur={() => handleBlur(item.ID, "seller")}
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleBlur(item.ID, "seller")
                          }
                          autoFocus
                        />
                      ) : (
                        item.seller
                      )}
                    </td>

                    <td
                      className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100"
                      onDoubleClick={() =>
                        handleEdit(item.ID, "salesDate", item.salesDate)
                      }
                    >
                      {editingRowId === `${item.ID}-salesDate` ? (
                        <input
                          type="date"
                          placeholder={formatDate(item.salesDate)}
                          className="w-full border-1"
                          value={editableFields[`${item.ID}-salesDate`] || ""}
                          onChange={(e) =>
                            setEditableFields((prev) => ({
                              ...prev,
                              [`${item.ID}-salesDate`]: e.target.value,
                            }))
                          }
                          onBlur={() => handleBlur(item.ID, "salesDate")}
                          onKeyDown={(e) =>
                            e.key === "Enter" &&
                            handleBlur(item.ID, "salesDate")
                          }
                          autoFocus
                        />
                      ) : (
                        formatDate(item.salesDate)
                      )}
                    </td>
                    <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                      <div className="relative inline-block text-left">
                        <div className="flex flex-row justify-around">
                          <button
                            type="button"
                            className={`inline-flex justify-around gap-x-1.5 rounded-md w-20 mr-1 py-2 text-sm font-semibold shadow-sm hover:bg-gray-500
                                            ${item.ourStat === "Sold"
                                ? "bg-green-500 text-white"
                                : ""
                              }
                                            ${item.ourStat === "Received"
                                ? "bg-blue-500 text-white"
                                : ""
                              }
                                            ${item.ourStat === "Sent"
                                ? "bg-yellow-500 text-white"
                                : ""
                              }
                                            ${item.ourStat === "Returned"
                                ? "bg-purple-500 text-white"
                                : ""
                              }
                                            ${item.ourStat === "Unpaid"
                                ? "bg-red-500 text-white"
                                : ""
                              }
                                            ${item.ourStat === "Custom"
                                ? "bg-black text-white"
                                : ""
                              }
                                            ${!item.ourStat
                                ? "bg-gray-100 text-blue-900"
                                : ""
                              }`}
                            id="menu-button"
                            aria-expanded={dropdownOpen === index}
                            aria-haspopup="true"
                            onClick={() => toggleDropdown(index)}
                          >
                            {item.ourStat || "options"}
                            <svg
                              className="-mr-1 h-5 w-5 text-gray-400"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              aria-hidden="true"
                            >
                              <path
                                fillRule="evenodd"
                                d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </button>
                        </div>
                        {dropdownOpen === index && (
                          <div
                            className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                            aria-orientation="vertical"
                            aria-labelledby="menu-button"
                            tabIndex="-1"
                          >
                            <div className="py-1">
                              <button
                                className="block w-full px-4 py-2 text-left text-sm text-gray-700 "
                                role="menuitem"
                                tabIndex="-1"
                                onClick={() =>
                                  handleOptionSelect(index, item.ID, "Sold")
                                }
                              >
                                Sold
                              </button>
                              <button
                                className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                role="menuitem"
                                tabIndex="-1"
                                onClick={() =>
                                  handleOptionSelect(index, item.ID, "Received")
                                }
                              >
                                Received
                              </button>
                              <button
                                className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                role="menuitem"
                                tabIndex="-1"
                                onClick={() =>
                                  handleOptionSelect(index, item.ID, "Custom")
                                }
                              >
                                Custom
                              </button>
                              <button
                                className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                role="menuitem"
                                tabIndex="-1"
                                onClick={() =>
                                  handleOptionSelect(index, item.ID, "Returned")
                                }
                              >
                                Returned
                              </button>
                              <button
                                className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                role="menuitem"
                                tabIndex="-1"
                                onClick={() =>
                                  handleOptionSelect(index, item.ID, "Repair")
                                }
                              >
                                Repair
                              </button>
                              <button
                                className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                role="menuitem"
                                tabIndex="-1"
                                onClick={() =>
                                  handleOptionSelect(index, item.ID, "Unpaid")
                                }
                              >
                                Unpaid
                              </button>
                              <button
                                className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                role="menuitem"
                                tabIndex="-1"
                                onClick={() =>
                                  handleOptionSelect(index, item.ID, "Lost")
                                }
                              >
                                Lost
                              </button>
                              <button
                                className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                role="menuitem"
                                tabIndex="-1"
                                onClick={() =>
                                  handleOptionSelect(index, item.ID, "Unknown")
                                }
                              >
                                Unknown
                              </button>
                              <button
                                className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                role="menuitem"
                                tabIndex="-1"
                                onClick={() =>
                                  handleOptionSelect(index, item.ID, "")
                                }
                              >
                                clear
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200 font-bold">
                  Total: {filteredData.length}
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                  -
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                  -
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                  -
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                  -
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                  -
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200 font-bold">
                  {totalBirrSum}
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                  -
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                  {totalSoldPrice}
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                  {totalProfit}
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                  -
                </td>
                <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100 font-bold">
                  -
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <EthioOthers />
        {showModal && (
          <div
            className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-10"
            onClick={closeModal} // Clicking the background closes the modal
          >
            <div
              className="rounded-lg shadow-lg max-w-lg relative bg-white p-2 pt-6"
              onClick={(e) => e.stopPropagation()} // Prevents closing when clicking inside modal
            >
              {/* Close Button */}
              <button
                className="absolute right-2 top-1 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full"
                // className="bg-red-500 px-2  text-white rounded-md hover:bg-red-600"
                onClick={closeModal}
              >
                x
              </button>

              {/* Image */}
              <img
                src={images[currentIndex]}
                alt="Preview"
                className="max-w-full max-h-[80vh] rounded-lg transition-transform duration-200 cursor-pointer"
                style={{ transform: `scale(${zoom})` }}
                onWheel={(e) =>
                  setZoom((prev) =>
                    Math.min(Math.max(prev + e.deltaY * -0.001, 1), 3)
                  )
                }
              />

              {/* Right Arrow */}
              {images.length > 1 && (
                <button
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full"
                  onClick={nextImage}
                >
                  ▶
                </button>
              )}
              {images.length > 1 && (
                <button
                  className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full"
                  onClick={prevImage}
                >
                  ◀
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default EthioProducts;
